import { Utils } from "./utils";

export class Spinner {
    element: HTMLElement | null;

    constructor(selector: string) {
        this.element = document.querySelector(selector);
    }

    show() {
        Utils.showContainer(this.element);
    }

    hide() {
        Utils.hideContainer(this.element);
    }
}
